import React, { useEffect, useRef, useState } from 'react';
import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import TranRptFormView from '../../../components/account/reports/tran_rpt/TranRptFormView';
import { useSidebar } from '../../../helpers/sidebarClose';
import TranRptListView from '../../../components/account/reports/tran_rpt/TranRptListView';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import PrintTransReportView from '../../../components/account/reports/tran_rpt/PrintTransReportView';
import { TransactionRpt } from '../../../helpers/models/Models';
import ProfitLossFormView from '../../../components/account/reports/profit_loss/ProfitLossFormView';
import ProfitLossRptListView from '../../../components/account/reports/profit_loss/ProfitLossRptListView';
import PrintProfitLossRptView from '../../../components/account/reports/profit_loss/PrintProfitLossRptView';

const ProfitAndLossReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('pl_report');
    const [onProfitLossReport, setOnProfitLossReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]); 
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Profit and Loss Report' />} open={isOpen} onClose={closeSidebar}>
                <ProfitLossFormView setOnProfitLossReport={setOnProfitLossReport} />
            </ReportDrawer>
            <ProfitLossRptListView onProfitLossReport={onProfitLossReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintProfitLossRptView onProfitLossReport={onProfitLossReport} />
                </div>
            </div>
        </>
    );
}

export default ProfitAndLossReportCreateListView;
